import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  assistantLabel: {
    alignItems: "center",
    display: "flex",
    fontSize: "14px",
    fontWeight: "700",
    gap: "8px",
    justifyContent: "center",
    marginBottom: "10px",
  },
  avatar: {
    alignItems: "center",
    backgroundColor: "#DBEAFE",
    borderRadius: "50%",
    display: "flex",
    height: "48px",
    justifyContent: "center",
    width: "48px",
  },
  avatarEmoji: {
    color: "#2563EB",
    fontSize: "18px",
    fontWeight: "bold",
  },
  container: {
    display: "flex",
    flex: "1",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
    padding: "0 12px",
  },
  containerWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  },
  errorContainer: {
    alignItems: "center",
    backgroundColor: "#FEF2F2",
    border: "1px solid #FECACA",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "16px",
    width: "100%",
  },
  errorText: {
    color: "#DC2626",
    fontSize: "14px",
    textAlign: "center",
  },
  inputSection: {
    flexShrink: 0,
    padding: "10px 12px 0 12px",
    position: "relative",
  },
  inputSectionWithBorder: {
    borderTop: "1px solid #E5E7EB",
  },
  loadingContainer: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    marginBottom: "4px",
    width: "100%",
  },
  mainContent: {
    alignItems: "center",
    display: "flex",
    flex: "1",
    flexDirection: "column",
    gap: "32px",
    justifyContent: "flex-start",
    overflow: "auto",
    paddingBottom: "20px",
    paddingTop: "32px",
  },
  mainTitle: {
    color: "#1F2937",
    fontSize: "24px",
    fontWeight: "600",
  },
  // New styles for when messages are present
  messagesContent: {
    display: "flex",
    flex: "1",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
  },
  processingIndicator: {
    alignItems: "center",
    display: "flex",
    gap: "8px",
    justifyContent: "center",
    marginBottom: "1rem",
  },
  tabContent: {
    display: "flex",
    flex: "1",
    flexDirection: "column",
    height: "100%",
  },
  tabsContainer: {
    borderBottom: "1px solid #E5E7EB",
    marginBottom: "16px",
    paddingBottom: "0px",
  },
  titleSection: {
    textAlign: "center",
  },
});
